<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logos">
          <img src="./assets/img/toplogo.png" alt />
        </div>
        <div class="radionstyle">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/download">党的建设</el-menu-item>

            <el-menu-item index="/case">产业体系</el-menu-item>
            <el-menu-item index="/product">研发中心</el-menu-item>
            <el-menu-item index="/goin">企业简介</el-menu-item>
          </el-menu>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <!-- <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>党的建设</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品与服务</p>
              <span>介绍视频</span>
              <span>管理模式</span>
            
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：yongguimeiji@126.com</span>
              <span>电话：18285728166 王杰</span>
              <span>地址：贵州省黔西县文峰街道循环经济工业园区</span>
            </li>
          </ul>
         
        </div>
        <div class="copyright">
          Copyright @2020-2020 贵州永贵机电制修有限公司 版权所有
          <a href="http://www.gzyngs.cn">黔ICP备2020011664号</a>
        </div>
      </div> -->

      <div id="footers" class="container-fluid" v-show="isShow">
        <div style="display:flex">
          <div class="footimages">
            <div class="footimagelogos">
              <img src="./assets/img/footerlogo.png" alt />
            </div>
          </div>
          <div class="footerlogo">
            <p class="title">贵州永贵机电制修有限公司</p>
            <div class="address_tel_fax">
              <div>地址：贵州省黔西县文峰街道循环经济工业园区</div>
              <div style="padding-right:120px">电话：18786512300 胡春华</div>
              <div style="padding-right:160px">传真：0857-7177888</div>
              <div style="padding-right:133px">信访电话：0857-7177888</div>
            </div>
            <p class="email_wx" style="padding-right:110px">
              <span>邮箱：yongguimeiji@126.com</span>
            </p>
            <!-- <p class="email_wx">
              Copyright @2020-2022 贵州永贵机电制修有限公司 版权所有
              <a href="https://beian.miit.gov.cn/" style="color:#fff">黔ICP备2020011664号</a>
          </p> -->
          </div>
          <div class="weixins">
            <div>
              <img src="./assets/img/henanweixin.png" />
            </div>
            <div>
              <img src="./assets/img/gzweixin.png" />
            </div>
            <div class="wenxintitles">关注官方公众号</div>
          </div>
        </div>

        <div class="copy">
          <div>
            <span>技术支持：信息化维保中心</span>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有：贵州永贵机电制修有限公司</span
            >
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;工信部网站备案查询
              <a href="https://beian.miit.gov.cn/" style="color:#fff"
                >黔ICP备2020011664号</a
              ></span
            >
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logos {
    width: 280px;
    padding: 10px;
    img {
      width: 110%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}
#footers {
  width: 100%;
  height: 370px;
  color: #fff;
  background: url("./assets/img/footer.png");
  overflow: hidden;
  text-align: center;
}
.footimages {
  border-right: 1px solid rgba(255, 255, 255, 0.28);
  height: 200px;
  width: 15%;
  padding-left: 100px;
  padding-top: 60px;
  .footimagelogos {
    width: 280px;
    padding-top: 30px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.weixins {
  height: 220px;
  width: 10%;
  padding-top: 30px;
  margin-left: 200px;
  .weixintitles {
    margin-top: 5px;
    font-size: 14px;
    line-height: 19px;
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
    word-wrap: break-word;
  }
  img {
    width: 45%;
    line-height: 60px;
  }
}
.footerlogo {
  border-right: 1px solid rgba(255, 255, 255, 0.28);
  height: 220px;
  width: 38%;
  padding-top: 45px;
  margin-left: 150px;
}
.title {
  font-size: 25px;
  padding-top: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px auto;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
// .footer {
//   width: 100%;
//   height: 216px;
//   overflow: hidden;
//   background-color: #14679f;
//   &-content {
//     width: 1240px;
//     margin: 0 auto;
//     padding-top: 20px;
//     display: flex;
//     justify-content: space-between;
//     .content-nav {
//       display: flex;
//       justify-content: space-around;
//       li {
//         display: flex;
//         flex-direction: column;
//         padding: 0 20px;
//         //justify-content: center;
//         align-items: flex-start;
//         p {
//           font-size: 20px;
//           color: #d4edff;
//           padding: 10px 0;
//         }
//         span {
//           color: #f7f7f7;
//           font-weight: 300;
//           padding: 5px 0;
//         }
//       }
//     }
//     img {
//       width: 170px;
//       height: 170px;
//       padding: 10px;
//     }
//   }
//   .copyright {
//     height: 30px;
//     background: #125688;
//     span {
//       color: #fff;
//       line-height: 30px;
//     }
//   }
// }
.el-radionstyle-demo {
  background-color: rgb(163, 172, 166);
  opacity: 0.4;
}
.copy {
  padding: 20px;
  background-color: #041730;
  height: 15px;
  color: #fff;
  font-size: 14px;
}
</style>
